import React from 'react'
import './DropdownTextInput.css'

function parseDropdownValue (value, options) {
  if (!value) return ''
  const textValue = parseInputValue(value, options)
  return (value.substring(0, value.length - textValue.length))
}

function parseInputValue (value, options) {
  if (!value) return ''
  let matchOpt = ''
  options.forEach(opt => {
    if (value.startsWith(opt) && matchOpt.length < opt.length) {
      matchOpt = opt
    }
  })
  return value.substring(matchOpt.length)
}

class RFDropdownTextInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }
  render () {
    let {input, meta, type, placeholder, dropdownOptions} = this.props
    const {value} = input
    let {touched, error} = meta

    const textValue = parseInputValue(value, dropdownOptions)
    const dropdownValue = parseDropdownValue(value, dropdownOptions)

    const dropdownValueView = (!dropdownValue) ? '(Select one)' : dropdownValue
    const dropdownStyle = {minWidth: 0}
    if (this.state.open) {
      dropdownStyle.display = 'block'
    } else {
      dropdownStyle.display = 'none'
    }

    return (
      <div className={`${this._wrapperClassName()}`}>
        <div className='input-group'>
          <div className='input-group-btn'>
            <button
              type='button'
              className='btn btn-default dropdown-toggle'
              onClick={() => { this.setState({open: !this.state.open}) }}
            >{dropdownValueView} <span className='caret' />
            </button>
            <ul className='dropdown-menu' style={{...dropdownStyle}}>
              {dropdownOptions.map((opt, idx) => {
                return <li key={idx}><a href='#' onClick={(e) => { this._onClickDropdown(e, opt) }}>{opt}</a></li>
              })}
            </ul>
          </div>
          <input
            {...input}
            value={textValue}
            type={type}
            className={`form-control`}
            placeholder={placeholder}
            onChange={this._onChange}
            onBlur={this._onBlur}
          />
        </div>
        {touched && error && <span className={`form-control-feedback glyphicon glyphicon-remove`} />}
        {touched && !error && <span className={`form-control-feedback glyphicon glyphicon-ok`} />}
        {touched && error && <span className='form-feedback'>{error}</span>}
      </div>
    )
  }

  _onClickDropdown = (e, opt) => {
    this.setState({
      open: false
    })
    const {input: {value, onChange}, dropdownOptions} = this.props
    const textValue = parseInputValue(value, dropdownOptions)
    onChange(`${opt}${textValue}`)
  }

  _wrapperClassName = () => {
    const {meta: {touched, error}} = this.props
    return `fields-text-field__wrapper ${touched ? (error ? 'has-feedback has-error' : 'has-feedback has-success') : ''}`
  }

  _onBlur = (e) => {
    const {input: {value, onBlur}} = this.props
    onBlur(value)
  }

  _onChange = (e) => {
    const {input: {value, onChange}, dropdownOptions} = this.props
    onChange(`${parseDropdownValue(value, dropdownOptions)}${e.target.value}`)
  }
}

export {RFDropdownTextInput}



// WEBPACK FOOTER //
// app/javascript/components/fields/DropdownTextInput/DropdownTextInput.js